import React from "react";
import { createDiscountCode, updateDiscountCode } from "../../../util/discount_code_api_utils";
import { fetchUsersNameAndIdOnly } from "../../../util/users_api_util";
import { fetchFirms } from "../../../util/settings_api_util";
import Select from 'react-select';
import debounce from 'debounce';
import { reactSelectDropdownStyles } from "../../../util/react_select_styles";

export default class AssignedDiscountCodeFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...(this.props.discount_code || {
        code: '',
        amount: null,
        expiration_date: null,
        percentage: false,
        assigned_user_id: null,
        brokerage_firm_id: null,
      }),
      errors: [],
      users: [],
      firms: [],
      userSearch: '',
      loadingUsers: false,
      assignmentType: this.props.discount_code?.assigned_user_id ? 'user' : (this.props.discount_code?.brokerage_firm_id ? 'firm' : 'user'),
      selectedUser: this.props.discount_code?.assigned_user ? {
        value: this.props.discount_code.assigned_user_id,
        label: `${this.props.discount_code.assigned_user.email}`
      } : null,
      selectedFirm: this.props.discount_code?.brokerage_firm ? {
        value: this.props.discount_code.brokerage_firm_id,
        label: this.props.discount_code.brokerage_firm.name
      } : null,
    }

    this.onSave = this.onSave.bind(this)
    this.onChange = this.onChange.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.onUserSearchChange = this.onUserSearchChange.bind(this)
    this.onUserChange = this.onUserChange.bind(this)
    this.onFirmChange = this.onFirmChange.bind(this)
    this.debounceFetchUsers = debounce(this.fetchUsers.bind(this), 500)
  }

  componentDidMount() {
    fetchFirms().then(firms => this.setState({ firms: firms }))
  }

  fetchUsers(search) {
    if (search && search.length > 2) {
      this.setState({ loadingUsers: true })
      fetchUsersNameAndIdOnly(search).then(users => {
        this.setState({ users: Object.values(users), loadingUsers: false })
      })
    }
  }

  onUserSearchChange(newValue) {
    this.setState({ userSearch: newValue })
    this.debounceFetchUsers(newValue)
  }

  onUserChange(selectedOption) {
    if (selectedOption) {
      this.setState({
        assigned_user_id: selectedOption.value,
        selectedUser: selectedOption,
        brokerage_firm_id: null,
        selectedFirm: null
      })
    } else {
      this.setState({ assigned_user_id: null, selectedUser: null })
    }
  }

  onFirmChange(selectedOption) {
    if (selectedOption) {
      this.setState({
        brokerage_firm_id: selectedOption.value,
        selectedFirm: selectedOption,
        assigned_user_id: null,
        selectedUser: null
      })
    } else {
      this.setState({ brokerage_firm_id: null, selectedFirm: null })
    }
  }

  onChange(e) {
    if (e.target.name === "code") {
      this.setState({ [e.target.name]: e.target.value.toUpperCase() });
    } else if (e.target.name === "assignmentType") {
      this.setState({
        assignmentType: e.target.value,
        assigned_user_id: null,
        selectedUser: null,
        brokerage_firm_id: null,
        selectedFirm: null
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  handleCheckbox(name) {
    this.setState({ [name]: !this.state[name] })
  }

  onSave() {
    const { percentage, amount, expiration_date, code, assigned_user_id, brokerage_firm_id } = this.state

    // Validation
    if (!assigned_user_id && !brokerage_firm_id) {
      this.setState({ errors: ['Please assign this coupon to a user or brokerage firm'] })
      return
    }

    let data = {
      percentage,
      amount,
      expiration_date,
      code,
      assigned_user_id,
      brokerage_firm_id
    }

    const save = this.state.id ? updateDiscountCode(this.state.id, data) : createDiscountCode(data)

    this.setState({ loading: true })

    save.then(discount_code => {
      this.props.closeModal()
      this.props.onSave(discount_code)
      this.setState({ loading: false })
    }).catch(response => {
      this.setState({ loading: false })
      this.setState({ errors: response.responseJSON || [] })
    })
  }

  render() {
    const userOptions = this.state.users.map(user => ({
      value: user.id,
      label: `${user.email} - ${user.role}`
    }))

    const firmOptions = this.state.firms.map(firm => ({
      value: firm.id,
      label: firm.name
    }))

    return (
      <div className="addFormModal">
        <div className="settingsModal">
          <div className="uploadPhotoModalHeadingGroup">
            <div className="uploadPhotoModalHeading">{this.state.id ? 'Update Coupon' : 'Create Coupon'}</div>
            <div className="closeIcon" onClick={() => this.props.closeModal()}><i className="fas fa-times"></i></div>
          </div>

          {this.state.errors.length > 0 && (
            <div className="alert alert-danger mt-4">{this.state.errors.join('. ')}</div>
          )}

          <div className="settingsCategoryGroup1">
            <div className="settingsServicesInput form-group">
              <label id="formLabel">Code</label>
              <input className="formInput" onChange={this.onChange} name="code" value={this.state.code} />
            </div>
            <div className="settingsServicesInput form-group">
              <label id="formLabel">Amount</label>
              <input className="formInput" onChange={this.onChange} type="string" name="amount" value={this.state.amount} />
            </div>
            <div className="settingsServicesInput form-group form-group-special">
              <label><input type="checkbox" className="formCheckBox" checked={this.state.percentage} onChange={() => this.handleCheckbox("percentage")} name="percentage" /> <span className="rememberMe">Percentage?</span></label>
            </div>
            <div className="settingsServicesInput form-group">
              <label id="formLabel">Expiration Date</label>
              <input className="formInput couponDateInput" onChange={this.onChange} name="expiration_date" type="date" placeholder="Expiration Date" value={this.state.expiration_date} />
            </div>

            <div className="settingsServicesInput form-group">
              <label id="formLabel">Assign To</label>
              <select className="formInput" name="assignmentType" value={this.state.assignmentType} onChange={this.onChange}>
                <option value="user">User</option>
                <option value="firm">Brokerage Firm</option>
              </select>
            </div>

            {this.state.assignmentType === 'user' && (
              <div className="settingsServicesInput form-group">
                <label id="formLabel">Select User</label>
                <Select
                  className="assignedDiscountCodeSelect"
                  placeholder="Search by email..."
                  isLoading={this.state.loadingUsers}
                  options={userOptions}
                  value={this.state.selectedUser}
                  onChange={this.onUserChange}
                  onInputChange={this.onUserSearchChange}
                  isClearable
                  styles={reactSelectDropdownStyles}
                />
              </div>
            )}

            {this.state.assignmentType === 'firm' && (
              <div className="settingsServicesInput form-group">
                <label id="formLabel">Select Brokerage Firm</label>
                <Select
                  className="assignedDiscountCodeSelect"
                  placeholder="Select a firm..."
                  options={firmOptions}
                  value={this.state.selectedFirm}
                  onChange={this.onFirmChange}
                  isClearable
                  styles={reactSelectDropdownStyles}
                />
              </div>
            )}
          </div>

          <button onClick={this.onSave} disabled={this.state.loading} className="settingsButton companyButton">
            Save
          </button>
        </div>
      </div>
    );
  }
}
